import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ff9bcaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "containerEditer",
  id: "containerEditer"
}
const _hoisted_2 = { class: "containerTabs" }
const _hoisted_3 = { class: "confirm" }

import { ref, onMounted, reactive, inject } from "vue";
import { useRouter, useRoute } from "vue-router";
import Ckeditor from "@/components/editCompoents/Ckeditor.vue";
import { postArticlesSave } from "@/api/functions/edit";
import {
  ArticleEditModel,
  initArticleEditModel,
  ArticleEditRequest,
  initArticleEditRequest,
} from "@/api/apitypes/request/ArticleEditRequest";
import {
  ArticleSearchRequest,
  initArticleSearchRequest,
} from "@/api/apitypes/request/ArticleSearchRequest";
import { postThemeArticle } from "@/api/functions/home";
import { ElMessage } from "element-plus";
import { reloadKey } from "@/functions/keys/index";
import { reloadFunction } from "@/functions/utils/CommonUtils";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditView',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const reload = inject(reloadKey) as reloadFunction;

const theme = ref(route.params.theme as string);
var articleEditRequest: ArticleEditRequest = initArticleEditRequest();
const cnArticleEditModel: ArticleEditModel = initArticleEditModel(
  theme.value,
  "zh"
);
const jaArticleEditModel: ArticleEditModel = initArticleEditModel(
  theme.value,
  "ja"
);
const enArticleEditModel: ArticleEditModel = initArticleEditModel(
  theme.value,
  "en"
);

const cnEdit = reactive(cnArticleEditModel);
const jpEdit = reactive(jaArticleEditModel);
const enEdit = reactive(enArticleEditModel);

function validate(): boolean {
  let valFlag: boolean = false;
  articleEditRequest.articleList.forEach((val, idx, array) => {
    if (theme.value.length > 0 && val.title != null && val.content != null) {
      valFlag = true;
      return;
    }
  });
  return valFlag;
}

// confirm button
async function handleConfirm() {
  if (cnEdit.title != "" && cnEdit.content != "") {
    cnEdit.theme = theme.value;
    articleEditRequest.articleList.push(cnEdit);
  }
  if (jpEdit.title != "" && jpEdit.content != "") {
    jpEdit.theme = theme.value;
    articleEditRequest.articleList.push(jpEdit);
  }
  if (enEdit.title != "" && enEdit.content != "") {
    enEdit.theme = theme.value;
    articleEditRequest.articleList.push(enEdit);
  }
  if (validate()) {
    const res = await postArticlesSave(articleEditRequest);
    ElMessage({
      message: "Congrats, Aiticle edited",
      showClose: true,
      type: "success",
    });

    if (theme.value !== "") {
      history.back();
    } else {
      router.push("/");
    }
  } else {
    articleEditRequest = initArticleEditRequest();
    ElMessage({
      message: "Oops,Please input title,content and theme.",
      showClose: true,
      type: "error",
    });
  }
}

const getArticleHandle = (articleSearchRequest: ArticleSearchRequest) => {
  articleSearchRequest.theme = theme.value;
  postThemeArticle(articleSearchRequest).then((res) => {
    res.data.articles.forEach((article, index, array) => {
      if (article.language === "zh") {
        Object.assign(cnEdit, article);
        return;
      }
      if (article.language === "ja") {
        Object.assign(jpEdit, article);
        return;
      }
      if (article.language === "en") {
        Object.assign(enEdit, article);
        return;
      }
    });
  });
};

onMounted(() => {
  if (theme) {
    const articleSearchRequest: ArticleSearchRequest =
      initArticleSearchRequest();

    getArticleHandle(articleSearchRequest);
  }
  var scrollDom = document.getElementById("containerEditer") as HTMLElement;
  scrollDom.scrollIntoView();
});

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_tabs, { type: "border-card" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, { label: "中文" }, {
            default: _withCtx(() => [
              _createVNode(Ckeditor, { languageEdit: cnEdit }, null, 8, ["languageEdit"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, { label: "日本語" }, {
            default: _withCtx(() => [
              _createVNode(Ckeditor, { languageEdit: jpEdit }, null, 8, ["languageEdit"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, { label: "English" }, {
            default: _withCtx(() => [
              _createVNode(Ckeditor, { languageEdit: enEdit }, null, 8, ["languageEdit"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_input, {
            modelValue: theme.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((theme).value = $event)),
            placeholder: "Please input theme(Maxlength:16)",
            maxlength: "16"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_button, {
              type: "primary",
              round: "",
              onClick: handleConfirm
            }, {
              default: _withCtx(() => [
                _createTextVNode("提交文章")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { round: "" }, {
              default: _withCtx(() => [
                _createTextVNode("存草稿")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { round: "" }, {
              default: _withCtx(() => [
                _createTextVNode("预览")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})